import React from 'react';
import { motion } from 'framer-motion'; // Import motion from framer-motion
import college from "../../assets/Home/college.jpg";
import SidebarGalleryPage from '../Main/Sidebargallery';

const Thecollege = () => {
  return (
    <div className="bg-gray-100 min-h-screen ">
      <div className="flex flex-wrap lg:flex-nowrap p-10 gap-8">
        {/* Left Section with Image and Content */}
        <motion.div
          className=""
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          <div>
            {/* Animated College Image */}
            <motion.img
              src={college}
              alt="CSE"
              className="w-full shadow-md p-2 border-4 border-teal-500 rounded-lg"
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
            />
          </div>
          <div>
            {/* Animated About College Section */}
            <motion.div
              className="mt-10 rounded-lg shadow-md"
              initial={{ opacity: 0, x: -100 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="border-4 border-teal-500 rounded-lg p-2">
                <h2 className="text-white bg-teal-500 p-2 font-bold rounded-sm text-xl">About College</h2>
                  <div className="mt-4 p-2 text-gray-800">
                    <p className="mb-4">
                      Government Women's Polytechnic College is located in Sehore and affiliated with Rajiv Gandhi Proudyogiki Vishwavidyalaya. The college is identified by its innovation and openness in the educational system by engaging students to participate in debates and development, offering vast opportunities through quality education.
                    </p>
                    <p>
                      The college is situated near Bhopal Naka at the west end of Sehore. The premises of the college are within a few minutes' walk from the Govt. P.G. College and Govt. Girls College. The campus is 3 Km from the Railway station and 1 Km from the main Bus Stand.
                    </p>
                  </div>
              </div>
            </motion.div>

            {/* Animated Another Section */}
            <motion.div
              className="mt-10 shadow-md"
              initial={{ opacity: 0, x: 100 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="border-4 border-teal-500 rounded-lg p-2">
                <h2 className="text-white bg-teal-500 p-2 font-bold rounded-sm text-xl">कॉलेज</h2>
                  <div className="p-2 mt-4 text-gray-800">
                    <p className="mb-2">
                      मध्यप्रदेश शासन तकनीकी शिक्षा विभाग डॉ बाबासाहेब आंबेडकर योजना अंतर्गत संचालित शासकीय महिला पॉलिटेक्निक महाविद्यालय सीहोर में अनुसूचित जाति वर्ग की छात्राओं के तीन वर्षीय पाठ्यक्रम कंप्यूटर साइंस एवं इंजीनियरिंग और मॉडर्न ऑफिस मैनेजमेंट में निशुल्क प्रवेश प्रक्रिया एमपी ऑनलाइन के माध्यम से शुरू की जाती है।
                    </p>
                  </div>
              </div>
            </motion.div>
          </div>
        </motion.div>
        
        {/* Right Section: Gallery */}
        <div className="w-full lg:w1/3">
        <SidebarGalleryPage />
        </div>
      </div>
    </div>
  );
};

export default Thecollege;